import { Loading } from "components/common";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { saveSearch } from "store/user.store";

const LoadingStatusStationContainer = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { id } = useParams()

    useEffect(() => {
        dispatch(saveSearch(id))
        navigate('/dashboard/status-sensors')
        // eslint-disable-next-line
    }, [id])

    return (<Loading />)
}

export default LoadingStatusStationContainer